import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Hammer from 'hammerjs';

import PhotoPermissionsUtil from '../../../../../helpers/permissions/PhotoPermissionsUtil';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import animator from '../../../../../helpers/animator';
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';  
import dataModel from '../../../../../models/DataModel';

import fileTypeQuestionIcon from '../../../../../assets/images/question-icon.svg';
import fileTypeCheckoff from '../../../../../assets/images/checkoff-icon.svg';
import fileTypeFormIcon from '../../../../../assets/images/forms-icon.svg';
import naIndicator from '../../../../../assets/images/na-indicator.svg';
import yesIndicator from '../../../../../assets/images/yes-indicator.svg';
import noIndicator from '../../../../../assets/images/no-indicator.svg';
import QuickCompleteSlideout from '../../../../../components/QuickCompleteSlideout';
import CompletionStepQuickActions from '../CompletionStepQuickActions';
import Iconoclast from '../../../../../components/Iconoclast';
import DataSource from '../../../../../dao/DataSource/DataSource';

import './TaskCompletionStep.scss';
import ImageTools from '../../../../../helpers/ImageTools';

const completion_step = {
  completion_criteria: {
    attachments: { conversions: {}, additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
    comments: {
      user: {},
    },
    form_fields: {},
    event_histories: {},
  },
};

export class TaskCompletionStep extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      expanded: false,
      expanding: false,
      contracting: false,
      completionStep: null,
      swipeDirection: Hammer.DIRECTION_RIGHT,
    };

    this.stepFileTypesToFullNames = {
      none: 'Check-off',
      doc: 'Document (.doc/.docx)',
      pdf: 'PDF (.pdf)',
      jpg: 'Photographs (.jpg/.png/.webp)',
      xls: 'Spreadsheet (.xls/.xlsx/.xlsm)',
      mp4: 'Video (.mp4/.mov)',
      Other: 'Other',
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.getCompletionStepTypeOption = this.getCompletionStepTypeOption.bind(this);
  }

  handleCSRetrieval(completionStep, action, acData, fetchedData) {
    this.setState({ completionStep });
  }

  componentDidMount() {
    const { task, firstInList, id } = this.props;
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    if (firstInList || task.status == 'pending_review' || task.status == 'pending_approval') {
      this.setState({ expanded: true });
    }

    if (id) {
      this.csDataSource = new DataSource('CompletionCriterion', id, completion_step, this.handleCSRetrieval);
      this.csDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
  }

  handleSetCardElement(element) {
    if (element && !this.cardElement) {
      this.cardElement = element;
      const swipeArea = new Hammer(this.cardElement, { touchAction: 'auto' });
      swipeArea.get('pan').set({ direction: Hammer.DIRECTION_ALL });
      const self = this;
      swipeArea.on('panleft panright', swipeEvent => {
        if (!self.props.isQuickActionAnimating) {
          self.handleSwipeEvent(swipeEvent);
        }
      });
    }
  }

  handleSwipeEvent(swipeEvent) {
    const isLeftSwipe = swipeEvent.direction == Hammer.DIRECTION_LEFT;
    if (isLeftSwipe || swipeEvent.direction == Hammer.DIRECTION_RIGHT) {
      if (swipeEvent.direction != this.state.swipeDirection) {
        this.setState({ swipeDirection: swipeEvent.direction });
        if (this.props.handleSlideout) {
          this.props.handleSlideout(isLeftSwipe ? this.state.completionStep.id : null);
        }
        if (isLeftSwipe) {
          this.analyticsLogger.logGenericCSEvent('QuickActionsSwipe');
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id != this.props.id) {
      if (this.csDataSource) {
        this.csDataSource.release();
      }
      if(this.props.id) {
        this.csDataSource = new DataSource('CompletionCriterion', this.props.id, completion_step, this.handleCSRetrieval);
        this.csDataSource.get();
      }
    }
    if (prevProps.activeSlideoutId != this.props.activeSlideoutId && 
      this.props.activeSlideoutId != this.props.id &&
      this.state.swipeDirection == Hammer.DIRECTION_LEFT){
      this.setState({ swipeDirection: Hammer.DIRECTION_RIGHT });
    }
  }

  getCompletionStepTypeOption() {
    const { completionStep } = this.state;
    if (completionStep) {
      if (completionStep.completion_type == 'boolean') {
        return 'Check-off';
      }
      else if (completionStep.requested_file_type) {
        return this.stepFileTypesToFullNames[completionStep.requested_file_type];
      }
      else return null;
    }
    else {
      return null;
    }
  }

  handleUpdateCallback(completionStep) {
    if (completionStep && completionStep.id) {
      this.setState({ completionStep });
    }
  }

  handleGetStatus() {
    const { completionStep } = this.state;
    const { task } = this.props;
    if (!completionStep) {
      return { text: 'Not Started', css: 'not-started' };
    }
    if(
      completionStep.rejected_at &&
      !completionStep.approved_at &&
      !completionStep.reviewed_at &&
      !completionStep.completed_at
    ) {
      return { text: 'Rejected', css: 'rejected' };
    } 
    else if (!completionStep.completed_at) {
      return { text: 'Not Started', css: 'not-started' };
    } 
    else if (!completionStep.reviewed_at && task.has_reviewer) {
      return { text: 'Pending Review', css: 'pending' };
    } 
    else if (!completionStep.approved_at && task.has_approver) {
      return { text: 'Pending Approval', css: 'pending' };
    } 
    else if (completionStep.approved_at) {
      return { text: 'Approved', css: 'approved' };
    } 
    else {
      return { text: 'Completed', css: 'approved' };
    }
  }

  handleArrowClick() {
    if(this.props.handleClickScroll) {

      this.props.handleClickScroll();

    }
    this.props.history.push({
      pathname: `/mobile/projects-tasks/task/${this.props.task.id}/completion_step/${this.state.completionStep.id}`,
      state: { userStepPermissions: this.props.userStepPermissions },
    });
  }

  handleExpansion() {
    if (this.state.expanded) {
      this.setState({ contracting: true, expanded: false });
    } else {
      this.setState({ expanding: true });
    }
  }

  fixExtension(extension) {
    if(extension) {
      let markStart = extension.indexOf('?');
      if (markStart >= 0) {
        extension = extension.substring(0, markStart);
      }
    }
    return extension;
  }

  handleTitleEnter(){
    this.hoverTimer = setTimeout(() => {
      this.setState({ hover: true });
    }, 750);
  }

  handleTitleLeave(){
    this.handleClearHoverTimer();
    if(this.state.hover){
      this.setState({ hover: false });
    }
  }
  handleClearHoverTimer(){
    clearTimeout(this.hoverTimer);
  }

  isTaskCompleteWithoutReviewers() {
    const { completionStep } = this.state;
    const { userStepPermissions, task } = this.props;
    if (completionStep && !completionStep.not_applicable &&
        (completionStep.completion_type == 'file_upload' || completionStep.completion_type == 'inspection') &&
        PhotoPermissionsUtil.canUserEditPhoto(userStepPermissions, completionStep, task)) {
      return true;
    }
    return false;
  }

  // TODO: this is causing a setState in render which we shouldn't be doing
  canViewDrawerPermissions() {
    const { completionStep } = this.state;
    const { task, permissions, userStepPermissions } = this.props;

    let completed = true;
    
    if (completionStep && completionStep.completed_at) {
      if (task.has_reviewer && !completionStep.reviewed_at) {
        completed = false;
      }
      if (task.has_approver && !completionStep.approved_at) {
        completed = false;
      }
      else if (!task.has_approver && !task.has_reviewer) {
        completed = false;
      }
    }
    else {
      completed = false;
    }
    if (!completed && permissions.canCompleteTask && 
        userStepPermissions && 
        (userStepPermissions.has('step_complete') || userStepPermissions.has('override') || this.isTaskCompleteWithoutReviewers())
    ) {
      return true;
    } else if (this.state.swipeDirection) {
      this.setState({ swipeDirection: null });
      return false;
    }
  }

  render() {
    const { completionStep, expanded } = this.state;
    if (!completionStep) {
      return null;
    }
    const status = this.handleGetStatus();
    const { firstInList, currentUser } = this.props;
    // handle props
    let typeImage = this.prevImage;
    if (completionStep.completion_type == 'boolean') {
      typeImage = fileTypeCheckoff;
    }
    else if (completionStep.completion_type == 'inspection') {
      typeImage = fileTypeQuestionIcon;
    }
    else if (completionStep.completion_type == 'form') {
      typeImage = fileTypeFormIcon;
    }
    else if (completionStep.requested_file_type) {
      typeImage = ImageTools.getIconForFile(completionStep.requested_file_type);
      this.prevImage = typeImage;
    }

    let numComments = completionStep.comments ? completionStep.comments.length : 0;

    let offlineIcon = null;
    if(completionStep._dirty){
      offlineIcon = <div className='offline-icon'>
        <Iconoclast type='offline-double' color='#9b9b9b' height='16px' width='21px'/>
      </div>;
    }
  
    let responseIndicator = null;
    if (completionStep.response != null) {
      switch (completionStep.response) {
      case 'N/A':
        responseIndicator = naIndicator;
        break;
      case 'YES':
        responseIndicator = yesIndicator;
        break;
      case 'NO':
        responseIndicator = noIndicator;
        break;
      default:
        break;
      }
    } else if (completionStep.not_applicable) {
      responseIndicator = naIndicator;
    }
    let rightSide = (
      <div className="right-side">
        <img
          className="completion-step-type"
          src={typeImage}
          alt="completion step type"
        />
        {numComments > 0 ? (
          <div className="comment-indicator">
            <div className="comment-count">{numComments}</div>
          </div>
        ) : null}
        {responseIndicator ? (<img className="response-indicator" src={responseIndicator} alt="Response"/>) : null}
      </div>
    );

    const quickActionsActive = this.state.swipeDirection == Hammer.DIRECTION_LEFT ? 'completion-step-banner--quick-action-active' : '';

    return (
      <div
        className={`task-completion-step ${firstInList ? 'first' : ''} ${
          expanded ? 'task-completion-step--expanded' : 'task-completion-step--contracted'
        }`}
        id={this.props.id} 
        ref={ element => { this.handleSetCardElement(element); }}
        onClick={!quickActionsActive ? this.handleArrowClick : undefined}
      >
        {offlineIcon}
        <div className={`completion-step-banner ${firstInList ? 'first' : ''}  ${quickActionsActive}`} onClick={!quickActionsActive ? this.handleExpansion : null}>
          <div className={'completion-step-info ' + status.css}>
            <div className="step-title">
              {completionStep.name.toUpperCase()}
            </div>
            <div className={'step-status ' + status.css}>{status.text} </div>
          </div>
          {rightSide}
        </div>
        {
          this.canViewDrawerPermissions() ?
          (
            <QuickCompleteSlideout
              id={completionStep.id}
              key={'quick-action-slideout' + completionStep.id}
              firstInList={firstInList}
              swipeDirection={this.state.swipeDirection}
              completionStep={completionStep}
              currentUser={currentUser}
              handleIsQuickActionAnimating={this.props.handleIsQuickActionAnimating}
            >
              <CompletionStepQuickActions
                key={'quick-action-detail-' + completionStep.id}
                completionStep={completionStep}
                navigateToCS={this.handleArrowClick}
                task={this.props.task}
                displayPhotoCarousel={this.props.displayPhotoCarousel}
                userStepPermissions={this.props.userStepPermissions}
                updateCallback={this.handleUpdateCallback}
                handleIsQuickActionAnimating={this.props.handleIsQuickActionAnimating}
                />
            </QuickCompleteSlideout>
          ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataModel: dataModel,
    actionCableUpdate: state.main.actionCableUpdate,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default withRouter(connect(mapStateToProps)(TaskCompletionStep));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskCompletionSteps/TaskCompletionStep/index.js